











































































import { Component, Prop, Vue } from 'vue-property-decorator';

import { Surface, Typography, Picture } from '@/components/atoms';
import CircleLock from '@/componentsV2/atoms/CircleLock/CircleLock.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';

import MarketingCenterCanvas from '@/components/organisms/MarketingCenterCanvas/MarketingCenterCanvas.vue';
import { IMarketingCenterPost } from '@/models/marketingCenter/post';
import {
  EMarketingCenterTemplates,
  IMarketingCenterTemplate
} from '@/models/marketingCenter/template';
import { EMarketingCenterColorSchemes } from '@/models/marketingCenter/colorScheme';
import { EMarketingCenterFormats } from '@/models/marketingCenter/format';
import { routes } from '@/router';

@Component({
  components: {
    Surface,
    Typography,
    Picture,
    MarketingCenterCanvas,
    CircleLock,
    FilledButton
  }
})
export default class MarketingCenterTemplateCard extends Vue {
  @Prop() slug!: EMarketingCenterTemplates;
  @Prop() template!: IMarketingCenterTemplate;
  @Prop({ default: [] }) specialCoinOffers!: any[];

  defaultTemplate = EMarketingCenterFormats.instagramPost;
  image: string = '';

  async mounted() {
    const canvas = this.$refs.canvas as any;
    this.image = await canvas.generateBase64(undefined, false);
  }

  get isRouterDisabled() {
    const route = routes.find(
      item =>
        item.meta.feature &&
        (this.template.button as any).link.includes(item.path)
    );

    if (!route || !route.meta.validator) return false;

    return !route.meta.validator().isValid;
  }

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get postData(): IMarketingCenterPost {
    return {
      title: this.template.placeholders.title,
      text: this.template.placeholders.text,
      color:
        this.template.placeholders.colorScheme ||
        EMarketingCenterColorSchemes.BLUE,
      template: this.template,
      brand: this.businessImage.src
    };
  }

  get business() {
    return this.$store.getters['business/getBusinessState'] || {};
  }

  get businessImage() {
    if (
      this.business &&
      this.business.logo &&
      this.business.logo.publicPath.small
    ) {
      return {
        src: this.business.logo.publicPath.small,
        id: this.business.logo.id
      };
    }

    return {};
  }

  get isSellCoinsActive() {
    return this.business.sellCoins;
  }

  get isDisabled() {
    if (this.slug === EMarketingCenterTemplates.GIFT) {
      return !this.isSellCoinsActive;
    } else if (this.slug === EMarketingCenterTemplates.OFFER) {
      return !this.hasSpecialCoinOffers;
    } else if (this.slug === EMarketingCenterTemplates.BIRTHDAY) {
      return !this.hasBirthdayOffers;
    } else if (this.slug === EMarketingCenterTemplates.LOYALTY) {
      return !this.hasRewardConfig;
    }

    return '';
  }

  get hasSpecialCoinOffers() {
    return this.specialCoinOffers.length;
  }

  get hasBirthdayOffers() {
    return this.specialCoinOffers.filter(
      (offer: any) => offer.specialType === 'Birthday'
    ).length;
  }

  get hasRewardConfig() {
    return (
      this.business.coinRewardPercentage &&
      this.business.coinRewardPercentage !== '0.00'
    );
  }

  goTo(link: string) {
    if (link) {
      this.$router.push({
        path: link
      });
    }
  }
}
